import { type OBLayout } from 'features/Bento/types/OBLayout';

/**
 * Default Bento layout
 */
const DefaultLayout: OBLayout = ({ children }) => <>{children}</>;

export default DefaultLayout;
